import React from 'react'
import dynamic from 'next/dynamic'
import Head from 'next/head'
import { createResource, useResource } from '@/lib/i18n'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'

const CareerBanner = dynamic(import('@/components/career/banner'))
const WorkWithUs = dynamic(import('@/components/career/work-with-us'))
const Pillars = dynamic(import('@/components/career/pillars'))
const HowToWork = dynamic(import('@/components/career/how-to-work'))
const ProcessVideo = dynamic(import('@/components/career/process-video'))
const GooglePlay = dynamic(import('@/components/common/google-play-btn'))
const Footer = dynamic(import('@/components/home/footer'))
const KPHead = dynamic(import('@/components/head'))
const TopNavigation = dynamic(import('@/components/top-navigation'))

const resource = createResource({
  en: {
    description:
      'Kredit Pintar is fast growing startup company. We have a vision to build and achieving financial inclusion in Indonesia. Working with us will develop your career. ',
  },
  id: {
    description:
      'Kredit Pintar adalah perusahaan startup yang berkembang pesat. Kami memiliki visi untuk membangun dan mencapai inklusi finansial di Indonesia. Berkerja dengan kami dapat mengembangkan karir Anda.',
  },
})

const Career = () => {
  const { t } = useResource(resource)
  const { width } = useWindowSize()

  return (
    <>
      <KPHead metaTitle="career" />
      <Head>
        <meta name="description" content={t('description')} />
      </Head>
      <TopNavigation />
      {width < 1000 && <div style={{ width: '100%', height: '1px' }}></div>}
      <CareerBanner />
      <WorkWithUs />
      <Pillars />
      <HowToWork />
      <ProcessVideo />
      <Footer />
      <GooglePlay />
    </>
  )
}

export default Career
